import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var UserOutlineSVG = function UserOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M15.955,4a5.038,5.038,0,0,1,5,5.065V10.5a7.851,7.851,0,0,1-2.393,5.322,2,2,0,0,0,.982,3.431l2.021.388c4.2,1.013,6.39,2.956,6.39,4.358v4h-24V24c0-1.406,2.21-3.359,6.391-4.359l1.995-.432a2,2,0,0,0,.944-3.415,7.71,7.71,0,0,1-2.33-5.293V9.064a5.037,5.037,0,0,1,5-5.064h0m0-2h0a7.031,7.031,0,0,0-7,7.065V10.5a9.685,9.685,0,0,0,2.963,6.754l-1.995.432C5.212,18.813,1.955,21.215,1.955,24v4a2,2,0,0,0,2,2h24a2,2,0,0,0,2-2V24c0-2.785-3.257-5.187-7.968-6.313l-2.065-.4A9.786,9.786,0,0,0,22.955,10.5V9.059a7.032,7.032,0,0,0-7-7.059Z"
  }));
};
UserOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(UserOutlineSVG);